import type { SVGProps } from 'react';

interface BookmakersIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const BookmakersIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & BookmakersIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 14 14"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#bookmakers-icon_svg__a)">
      <path
        clipRule="evenodd"
        d="M1.25 2.675c0-.362.253-.55.442-.55h6.543v1.266a.875.875 0 1 0 1.75 0V2.125h2.323c.189 0 .442.188.442.55V4.42c-.908.472-1.5 1.47-1.5 2.58s.592 2.108 1.5 2.58v1.745c0 .362-.253.55-.442.55H9.985v-1.266a.875.875 0 1 0-1.75 0v1.266H1.692c-.189 0-.442-.188-.442-.55V9.589C2.167 9.12 2.767 8.116 2.767 7s-.6-2.12-1.517-2.59zm7.86 10.45H1.692c-.99 0-1.692-.864-1.692-1.8V9.167c0-.278.184-.523.452-.6C1.03 8.4 1.517 7.79 1.517 7S1.03 5.6.452 5.433a.625.625 0 0 1-.452-.6V2.675c0-.936.702-1.8 1.692-1.8h10.616c.99 0 1.692.864 1.692 1.8v2.162c0 .277-.181.52-.446.6-.574.17-1.054.777-1.054 1.563s.48 1.392 1.054 1.564c.265.079.446.322.446.599v2.162c0 .936-.702 1.8-1.692 1.8zm.875-7.07a.875.875 0 0 0-1.75 0v1.89a.875.875 0 1 0 1.75 0z"
        fill="#4FA9FF"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="bookmakers-icon_svg__a">
        <path d="M0 0h14v14H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
